import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Heading from "core/Heading";
import BodyText from "core/BodyText";
import colors from "core/colors";
import OrderSummaryItem from "./OrderSummaryItem";
import {
    StyledOrderSummary,
    UsdBodyText,
    TotalCharge,
    SubsOrderItem
} from "./styles";
import {
    PRO_MONTHLY_PLAN,
    monthlySubTitle,
    yearlySubTitle
} from "subscriptions/data";

const OrderSummaryBody = ({
    orderSummaryTextLine1,
    orderSummaryTextLine2,
    thumbnail,
    itemTitle,
    className,
    itemPrice,
    itemPriceOrderSummaryItem,
    showOrderSummary = true,
    isSubscription = ""
}) => {
    return (
        <StyledOrderSummary className={className}>
            {showOrderSummary && (
                <>
                    <Heading type="h2" size="xs" headingColor={colors.midnight}>
                        Order Item
                    </Heading>

                    {!isSubscription ? (
                        <OrderSummaryItem
                            className={className}
                            thumbnail={thumbnail}
                            itemTitle={itemTitle}
                            itemPriceOrderSummaryItem={
                                itemPriceOrderSummaryItem
                            }
                            orderSummaryTextLine1={orderSummaryTextLine1}
                            orderSummaryTextLine2={orderSummaryTextLine2}
                        />
                    ) : (
                        <SubsOrderItem>
                            {isSubscription === PRO_MONTHLY_PLAN
                                ? monthlySubTitle
                                : yearlySubTitle}
                        </SubsOrderItem>
                    )}
                </>
            )}

            <TotalCharge
                justifyContent="space-between"
                alignItems="baseline"
                showOrderSummary={showOrderSummary}
            >
                <BodyText type="p" size="sm" copyColor={colors.midnight}>
                    Charged today
                </BodyText>

                <Heading
                    type="p"
                    size="xs"
                    headingColor={colors.midnight}
                    alignment="right"
                >
                    <UsdBodyText type="span" size="sm" copyColor={colors.storm}>
                        USD
                    </UsdBodyText>
                    ${itemPrice}
                </Heading>
            </TotalCharge>
        </StyledOrderSummary>
    );
};

const OrderSummary = styled(OrderSummaryBody)``;

OrderSummary.propTypes = {
    className: PropTypes.string,
    thumbnail: PropTypes.string,
    itemTitle: PropTypes.string,
    itemPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    orderSummaryTextLine1: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    orderSummaryTextLine2: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    showOrderSummary: PropTypes.bool.isRequired,
    isSubscription: PropTypes.string
};

export default OrderSummary;
